import { backendService } from "services"

export const getTotalCountUserNotification = async (
  userId,
  tenant
) => {
  return await backendService.get(`/user-notification/total-count?userId=${userId}&companyKey=${tenant}`)
}

export const getUserNotifications = async (
  userId,
  tenant,
  page,
  perPage,
  titleSearchContent
) => {
  return await backendService.get(`/user-notification?userId=${userId}&companyKey=${tenant}&page=${page}&perPage=${perPage}&titleSearchContent=${titleSearchContent}`)
}
